import { IMO } from '../models/voyage-imo-model';
import { authFetchGET } from '../utils/auth-fetch';

const isVesselOnCloud = (<any>window)['appenv'].vesselOnCloud;
const loadstarApi = (<any>window)['appenv'].services.loadstarApi;
const env = { ...loadstarApi, ...isVesselOnCloud ? { scope: (<any>window)['appenv'].scope } : {} };

interface LoadstarExistsResponse {
    imo: string;
    exists: boolean;
}

interface LoadstarErrorResponse {
    error: string;
}

export class LoadstarService {
    static async checkVesselExists(imo: IMO): Promise<boolean> {
        if (!imo) {
            return false;
        }

        try {
            const data: LoadstarExistsResponse | LoadstarErrorResponse = await authFetchGET(
                env.scope,
                `${env.baseurl}/${imo}/exists`,
            );

            if ('error' in data) {
                console.warn('Failed to check loadstar data', data.error);
                return false;
            }

            return data.exists === true;
        } catch (error) {
            console.warn('Failed to check loadstar data', error);
            return false;
        }
    }

     static async getValuesFromLoadstar(imo: IMO, scheduleid: string, voyageNo: string): Promise<any> {
        if (!imo) {
            return false;
        }

        try {
            const data: any  = await authFetchGET(
                env.scope,
                `${env.baseurl}/${imo}/values/${scheduleid}/${voyageNo}`,
            );

            if ('error' in data) {
                console.warn('Failed to check loadstar data', data.error);
                return null
                //for local testing- remove once loadstar data is available
                // return  {"fore_draft": 4.96,"aft_draft": 6.51,"fluid_gm": 23.2,"solid_gm": 1.2,"live_reefers": 5,"max_roll_angle": 3,"voyage_number": "123A","departure_port": "AEABU","arrival_port": "AEAJM","saved_at": "2026-04-07T10:15:30Z"};
            }

            return data.values;
        } catch (error) {
            console.warn('Failed to check loadstar data', error);
            return null
            //for local testing- remove once loadstar data is available
            // return  {"fore_draft": 4.96,"aft_draft": 6.51,"fluid_gm": 23.2,"solid_gm": 1.2,"live_reefers": 5,"max_roll_angle": 3,"voyage_number": "123A","departure_port": "AEABU","arrival_port": "AEAJM","saved_at": "2026-04-07T10:15:30Z"};
        }
    }
}
